export default __webpack_public_path__ + "static/media/Star 4.dc34b18c.svg";